export default {
  SET_SEGMENTS: 'SET_PROJECT_SEGMENTS',
  ASSOCIATE_SEGMENTS_REQUEST: 'ASSOCIATE_PROJECT_SEGMENTS_REQUEST',
  ASSOCIATE_SEGMENTS_SUCCESS: 'ASSOCIATE_PROJECT_SEGMENTS_SUCCESS',
  ASSOCIATE_SEGMENTS_FAILURE: 'ASSOCIATE_PROJECT_SEGMENTS_FAILURE',
  TOGGLE_SEGMENT: 'TOGGLE_PROJECT_SEGMENT'
}
